import { useAppContext, useDeepEffect } from '../../hooks';

type DynamicPageTitleProps = {
  children: React.ReactNode;
};

export const DynamicPageTitle: React.FC<DynamicPageTitleProps> = ({
  children,
}) => {
  const { addTitle, removeTitle } = useAppContext();

  useDeepEffect(() => {
    const titleId = addTitle(children);

    return () => {
      removeTitle(titleId);
    };
  }, [children, addTitle, removeTitle]);

  return null;
};
